import React, { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import MoralisDappContext from './context';

// Simplified provider that uses web3-react instead of Moralis
function MoralisDappProvider({ children }) {
  const { account, chainId: web3ChainId } = useWeb3React();
  const [walletAddress, setWalletAddress] = useState();
  const [chainId, setChainId] = useState();

  useEffect(() => {
    if (account) {
      setWalletAddress(account);
    }
  }, [account]);

  useEffect(() => {
    if (web3ChainId) {
      setChainId(`0x${web3ChainId.toString(16)}`);
    }
  }, [web3ChainId]);

  return (
    <MoralisDappContext.Provider value={{ walletAddress, chainId }}>
      {children}
    </MoralisDappContext.Provider>
  );
}

function useMoralisDapp() {
  const context = React.useContext(MoralisDappContext);
  if (context === undefined) {
    throw new Error('useMoralisDapp must be used within a MoralisDappProvider');
  }
  return context;
}

export { MoralisDappProvider, useMoralisDapp };
